import {useEffect, useRef} from 'react'
import arePassiveEventsSupported from "are-passive-events-supported";

function useOnClickOutside(ref, handler) {

    const haveHandler = Boolean(handler);
    const handlerRef = useRef(handler);
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    const listenerRef = useRef(null);
    useEffect(() => {
        const listener = listenerRef.current = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            if (typeof handlerRef.current === 'function') {
                handlerRef.current(event);
            }
        };
        document.addEventListener(
            'mousedown', listener
        );
        document.addEventListener(
            'touchstart', listener,
            arePassiveEventsSupported() ? { passive: true } : undefined
        );
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, haveHandler, handlerRef, listenerRef]);
}

export default useOnClickOutside;
